import all_done from 'assets/empty_state_images/all_done.svg';
import no_comments from 'assets/empty_state_images/no_comments.svg';
import no_entities from 'assets/empty_state_images/no_entities.svg';
import no_excel_file from 'assets/empty_state_images/no_excel_file.svg';
import no_files from 'assets/empty_state_images/no_files.svg';
import no_historical_categorizations from 'assets/empty_state_images/no_historical_categorizations.svg';
import no_messages from 'assets/empty_state_images/no_messages.svg';
import no_messages_2 from 'assets/empty_state_images/no_messages_2.svg';
import no_notification from 'assets/empty_state_images/no_notification.svg';
import no_report from 'assets/empty_state_images/no_report.svg';
import no_search_result from 'assets/empty_state_images/no_search_result.svg';
import no_subtask from 'assets/empty_state_images/no_subtask.svg';
import no_tasks from 'assets/empty_state_images/no_tasks.svg';
import no_transaction from 'assets/empty_state_images/no_transaction.svg';

export const imageConfig = {
  all_done: all_done,
  no_comments: no_comments,
  no_excel_file: no_excel_file,
  no_files: no_files,
  no_historical_categorizations: no_historical_categorizations,
  no_messages_2: no_messages_2,
  no_messages: no_messages,
  no_notification: no_notification,
  no_report: no_report,
  no_search_result: no_search_result,
  no_subtask: no_subtask,
  no_tasks: no_tasks,
  no_transaction: no_transaction,
  no_entities: no_entities,
};
